// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#loading[data-v-3df8aa82] {\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 10000;\n}\n", ""]);
// Exports
module.exports = exports;
